export const SET_LOGS = 'SET_LOGS';
export const SET_LOG = 'SET_LOG';
export const ADD_LOG = 'ADD_LOG';
export const ADD_LOGS = 'ADD_LOGS';
export const UPDATE_LOG = 'UPDATE_LOG';
export const REMOVE_LOG = 'REMOVE_LOG';
export const CLEAR_LOG = 'CLEAR_LOG';
export const CLEAR_LOGS = 'CLEAR_LOGS';
